import { render, staticRenderFns } from "./scene9.vue?vue&type=template&id=1cc27cf5&"
import script from "./scene9.vue?vue&type=script&lang=js&"
export * from "./scene9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports